import ReportingOptionState from './schema/ReportingOptionState';
import { createStore } from 'satcheljs';

export default createStore<ReportingOptionState>('reportingOptionState', {
    reportJunkSelected: null,
    checkForReportJunkDialog: null,
});
